var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('meter',{staticClass:"timer__meter",attrs:{"min":_vm.startTime,"max":_vm.startTime + _vm.durationN,"value":_vm.currentTime}})])
}
var staticRenderFns = []

export { render, staticRenderFns }